/*
 * @Author: wangxiang
 * @Date: 2019-11-24 15:53:45
 * @Last Modified by: wangxiang
 * @Last Modified time: 2019-12-02 21:44:53
 */
export default {
  routes: [
    {
      path: '/skip',
      name: 'skip',
      component: () => import('@/module/download/Skip.vue'),
      meta: {
        title: '下载',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/publicAccount',
      name: 'publicAccount',
      component: () => import('@/module/brandMiniPrograme/index.vue'),
      meta: {
        title: '关注公众号',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/posterGallery',
      name: 'posterGallery',
      component: () => import('@/module/download/ArtPosterNew.vue'),
      meta: {
        title: '学员书画馆海报',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/posterExhibition',
      name: 'posterExhibition',
      component: () => import('@/module/download/ExhibitionPoster.vue'),
      meta: {
        title: '3d艺术馆海报',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/pointPoster',
      name: 'pointPoster',
      component: () => import('@/module/download/PointPoster.vue'),
      meta: {
        title: '积分商城海报',
        keepAlive: false,
        logined: false,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/Download.js